var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximiseMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0V5.25H22.5V2.56073L18.5304 6.53037L17.4696 5.46964L21.4393 1.5H18.75V0H24ZM5.46964 17.4696L1.5 21.4393V18.75H0V24H5.25V22.5H2.56073L6.53037 18.5304L5.46964 17.4696ZM22.5 21.4393L18.5304 17.4696L17.4696 18.5304L21.4393 22.5H18.75V24H24V18.75H22.5V21.4393ZM1.5 2.56073L5.46964 6.53037L6.53037 5.46964L2.56073 1.5H5.25V0H0V5.25H1.5V2.56073ZM9 9H11.25V7.5H7.5V11.25H9V9ZM16.5 7.5H12.75V9H15V11.25H16.5V7.5ZM16.5 12.75H15V15H12.75V16.5H16.5V12.75ZM11.25 15H9V12.75H7.5V16.5H11.25V15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximiseMap);
export default __webpack_public_path__ + "static/media/maximise-map.15aec1d45997d5d24376b8bcd04f5df9.svg";
export { ForwardRef as ReactComponent };